import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Icon, Badge, Tabs, Button, List, Progress, message } from 'antd';
import { getData } from '@util';
import {
  API_POST_TASK_STAT,
  API_POST_CANCEL_TASK,
  API_GET_TASK,
  API_POST_TASK_CLEAR,
  API_GET_DOWNLOAD_FILE,
  API_POST_RETRY_TASK,
} from '@api';
import { hasAttach, getAttach, getTaskStatus } from './util';
import OpenNotification from './Notification.jsx';
import styles from './style/taskCenter.scss';

// message.config({ prefixCls: 'csx-message' })

const { TabPane } = Tabs;
class TaskCenter extends Component {
  static defaultProps = {
    sysCode: '',
    timeOut: 2500,
  };
  constructor(props) {
    super(props);
    this.state = {
      pendingTasks: [],
      resolvedTasks: [],
      rejectedTasks: [],
      runningCount: 0,
      waitingCount: 0,
      key: '1', //tab索引
    };
    this.timer = null; //定时器
    this.timeOut = props.timeOut; //getTasks定时器间隔
    this.sysCode = props.sysCode; //系统编码,传参需要用到
    this.socket = null;
    this.isInt = true; //是否是第一次加载
  }

  componentDidMount() {
    //默认先加载一次,获取当前用户的所有任务列表
    this._getTasksList(this.sysCode);
    // this._getStatCount();
    //每隔timeOut刷新一次
    this.timer = setInterval(() => {
      this._getTasksList(this.sysCode);
      // this._getStatCount();
    }, this.timeOut);
  }
  componentWillUnmount() {
    this.timer && clearInterval(this.timer);
  }

  //更新任务列表
  _updateTasksList = data => {
    const { taskResult } = data;
    const { history, timeOut } = this.props;
    const { pendingTasks } = this.state;
    if (
      taskResult === 1 &&
      pendingTasks.some(i => `${i.taskResult}${i.id}` === `${taskResult}${data.id}`)
    ) {
      this._getTasksList(this.sysCode);
    } else {
      OpenNotification(data, history, timeOut);
      this._getTasksList(this.sysCode);
    }
  };
  _getStatCount = () => {
    const { sysCode } = this;
    const { taskType } = this.props;
    const data = { sysCode, taskType };
    getData({ api: API_POST_TASK_STAT, data }).then(res => {
      const { runningCount, waitingCount } = res.data || {};
      this.setState({ runningCount, waitingCount });
    });
  };
  //获取任务列表
  _getTasksList = sysCode => {
    const { taskType, taskType2, taskType3, taskType4, timeOut, history } = this.props;
    const searchParams = { sysCode, taskType };
    const scheduleParams = {
      sysCode: sysCode,
      taskType: taskType2,
    };
    const tmsParams = { sysCode, taskType: taskType3 };
    const { pendingTasks, resolvedTasks, rejectedTasks } = this.state;
    const _pendingTasks = [],
      _resolvedTasks = [],
      _rejectedTasks = [];
    Promise.all([
      getData({ api: API_GET_TASK, searchParams: scheduleParams }),
      getData({ api: API_GET_TASK, searchParams }),
      getData({ api: API_GET_TASK, searchParams: tmsParams }),
      getData({ api: API_GET_TASK, searchParams: { sysCode, taskType: taskType4 } }),
    ]).then(res => {
      const [res1, res2, res3, res4] = res;
      if (res1.code === 200000 && res1.data && res1.data.length > 0) {
        res1.data.forEach(item => {
          const { taskResult } = item;
          switch (taskResult) {
            case 1:
              _pendingTasks.push(item);
              break;
            case 2:
              _resolvedTasks.push(item);
              break;
            case 3:
              _rejectedTasks.push(item);
              break;
          }
        });
      }
      if (res2.code === 200000 && res2.data && res2.data.length > 0) {
        res2.data.forEach(item => {
          const { taskResult } = item;
          switch (taskResult) {
            case 1:
              _pendingTasks.push(item);
              break;
            case 2:
              _resolvedTasks.push(item);
              break;
            case 3:
              _rejectedTasks.push(item);
              break;
          }
        });
      }
      if (res3.code === 200000 && res3.data && res3.data.length > 0) {
        res3.data.forEach(item => {
          const { taskResult } = item;
          switch (taskResult) {
            case 1:
              _pendingTasks.push(item);
              break;
            case 2:
              _resolvedTasks.push(item);
              break;
            case 3:
              _rejectedTasks.push(item);
              break;
          }
        });
      }
      if (res4.code === 200000 && res4.data && res4.data.length > 0) {
        res4.data.forEach(item => {
          const { taskResult } = item;
          switch (taskResult) {
            case 1:
              _pendingTasks.push(item);
              break;
            case 2:
              _resolvedTasks.push(item);
              break;
            case 3:
              _rejectedTasks.push(item);
              break;
          }
        });
      }
      this.setState(
        {
          pendingTasks: _pendingTasks,
          resolvedTasks: _resolvedTasks,
          rejectedTasks: _rejectedTasks,
        },
        () => {
          if (!this.isInt) {
            _pendingTasks.forEach(item => {
              if (pendingTasks.every(i => i.id !== item.id)) {
                OpenNotification(item, history, timeOut);
              }
            });
            _resolvedTasks.forEach(item => {
              if (resolvedTasks.every(i => i.id !== item.id)) {
                OpenNotification(item, history, timeOut);
              }
            });
            _rejectedTasks.forEach(item => {
              if (rejectedTasks.every(i => i.id !== item.id)) {
                OpenNotification(item, history, timeOut);
              }
            });
          }
          this.isInt = false;
        },
      );
    });
  };
  //渲染执行失败的错误message
  renderTaskMessage = taskMessage => {
    const taskMessageStyle = {
      color: 'red',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '310px',
    };
    return (
      <div title={taskMessage} style={taskMessageStyle}>
        <Icon type="warning" />
        {taskMessage}
      </div>
    );
  };

  cancelTask = (taskAttach, id) => {
    this.setState({ [`${id}cancelLoading`]: true });
    getData({ api: API_POST_CANCEL_TASK, data: { taskId: id } }).then(
      res => {
        this.setState({ [`${id}cancelLoading`]: false });
        message.success('已取消');
        this._getTasksList(this.sysCode);
      },
      () => {
        this.setState({ [`${id}cancelLoading`]: false });
      },
    );
  };

  retryTask = (taskAttach, id) => {
    this.setState({ [`${id}retryLoading`]: true });
    getData({ api: API_POST_RETRY_TASK, replaceParams: { id } }).then(
      res => {
        this.setState({ [`${id}retryLoading`]: false });
        message.loading('正在重试');
        this._getTasksList(this.sysCode);
      },
      () => {
        this.setState({ [`${id}retryLoading`]: false });
      },
    );
  };

  renderItem = (item, status, hasExtra = false) => {
    const {
      id,
      taskName, //任务名称
      taskAttach,
      createTime, //创建时间
      progressPercent, //进度条百分比
      taskResult, //任务结果
      taskParam, //任务的参数,包括'是不是导入','导入的路径','报错导出的路径'
      taskData,
      taskMessage,
    } = item;
    let taskParamObj = {};
    try {
      taskParamObj = JSON.parse(taskParam);
    } catch (error) {
      // window.console.log(error)
    }
    const param = taskParamObj.taskParam || taskParamObj || {};
    const {
      isImport, //判断是否是导入
      returnPath, //导入成功跳转的地址
    } = param;
    const btnProps = {
      style: { position: 'absolute', right: 15, top: 6 },
      size: 'small',
      onClick: isImport
        ? taskResult === 2
          ? this.goTo.bind(this, returnPath)
          : taskResult === 1
          ? this.cancelTask.bind(this, taskAttach, id)
          : hasAttach(taskAttach)
          ? this.errorExport.bind(this, taskAttach, id)
          : this.retryTask.bind(this, taskAttach, id)
        : taskResult === 1
        ? this.cancelTask.bind(this, taskAttach, id)
        : taskResult === 3
        ? this.retryTask.bind(this, taskAttach, id)
        : this.handleDownload.bind(this, taskAttach, id),
    };
    const extra = () => {
      const { itemExtra } = this.props;

      if (typeof itemExtra === 'function') return itemExtra(item);
      if (taskResult === 2) {
        //成功的任务
        return (
          hasAttach(taskAttach) && (
            <Button {...btnProps} loading={this.state[`${id}downLoading`]}>
              {isImport ? '查看' : '下载'}
            </Button>
          )
        );
      } else if (taskResult === 3) {
        //失败的任务
        // return isImport ? /*<Button {...btnProps} loading={this.state[`${id}errorLoading`]}>导出报错</Button>*/ undefined : (
        //   <Button {...btnProps} loading={this.state[`${id}retryLoading`]}>
        //     重试
        //   </Button>
        // );
        //失败的任务
        return isImport && hasAttach(taskAttach) ? (
          <Button {...btnProps} loading={this.state[`${id}errorLoading`]}>
            导出报错
          </Button>
        ) : (
          <Button {...btnProps} loading={this.state[`${id}retryLoading`]}>
            重试
          </Button>
        );
      } else if (taskResult === 1) {
        return (
          <Button {...btnProps} loading={this.state[`${id}cancelLoading`]}>
            取消
          </Button>
        );
      } else {
        return undefined;
      }
    };
    const attachInfo = getAttach(taskAttach);
    const title = attachInfo && this.sysCode === 'TASK-SCHEDULING' ? attachInfo.name : taskName;

    // 获取任务状态
    const taskStatus = getTaskStatus(taskData);
    let showStatus = status;
    if (taskStatus === 1) {
      showStatus = 'exception';
    }
    //  将任务执行失败的消息提醒 设置成统一的文案
    let messagUniform = '系统繁忙，本次任务执行失败，请5分钟后重试！';
    if (isImport && taskMessage) {
      // 导入的失败消息提示传入
      messagUniform = taskMessage;
    }
    return (
      <List.Item extra={hasExtra && extra()}>
        <List.Item.Meta
          title={title}
          description={
            <div>
              {taskResult === 3 && this.renderTaskMessage(messagUniform)}
              <div>{createTime}</div>
              <Progress style={{ width: '100%' }} percent={progressPercent} status={showStatus} />
            </div>
          }
        />
      </List.Item>
    );
  };
  //下载按钮
  handleDownload = (taskAttach, id) => {
    const toggleLoading = boolean => this.setState({ [`${id}downLoading`]: boolean });
    toggleLoading(true);
    const taskAttachArr = taskAttach ? JSON.parse(taskAttach) : [];
    if (taskAttachArr && taskAttachArr.length) {
      const { name, url } = taskAttachArr[0];
      const searchParams = { name, url };
      getData({ api: API_GET_DOWNLOAD_FILE, searchParams }).then(
        res => toggleLoading(false),
        err => toggleLoading(false),
      );
    } else {
      toggleLoading(false);
      message.error('尴尬,好像找不到下载地址');
    }
  };
  //导入成功跳转到指定页面
  goTo = returnPath => {
    const path = `/sell${returnPath}`;
    if (returnPath) {
      this.props.history.push('/sell/404');
      //new Promise().then(()=>{this.props.history.push(path)})
      setTimeout(() => {
        this.props.history.push(path);
      }, 0);
    } else {
      message.error('跳转失败');
    }
  };
  //导入失败导出报错信息
  errorExport = (taskAttach, id) => {
    const toggleLoading = boolean => this.setState({ [`${id}errorLoading`]: boolean });
    const taskAttachArr = taskAttach ? JSON.parse(taskAttach) : [];
    if (taskAttachArr && taskAttachArr.length) {
      const { url, name } = taskAttachArr[0];
      const searchParams = { name, url };
      toggleLoading(true);
      getData({ api: API_GET_DOWNLOAD_FILE, searchParams }).then(
        res => toggleLoading(false),
        err => toggleLoading(false),
      );
    } else {
      toggleLoading(false);
      message.error('尴尬,好像找不到下载地址');
    }
  };
  //删除按钮
  handleClearTasks = () => {
    const { key } = this.state;
    const names = ['pendingTasks', 'resolvedTasks', 'rejectedTasks'];
    const namesCN = ['执行中的任务', '执行完成的任务', '执行失败的任务'];
    const data = { status: key, sysCode: this.sysCode };
    const name = names[key - 1];
    const nameCN = namesCN[key - 1];
    //执行中的任务不能清空
    if (key === '1') return message.error(`${nameCN}不能清空`);
    //如果任务数为0 return
    if (!this.state[name].length) return message.error(`暂无${nameCN}`);

    this.setState({ clearBtnLoading: true });
    getData({ api: API_POST_TASK_CLEAR, data }).then(
      res => {
        if (res && res.code === 200000) {
          message.success(`${nameCN}已清空`);
          this.setState({ clearBtnLoading: false, [name]: [] }, () =>
            this._getTasksList(this.sysCode),
          );
        }
      },
      () => {
        this.setState({ clearBtnLoading: false });
      },
    );
  };
  renderFooter = () => {
    const { runningCount, waitingCount, clearBtnLoading, key } = this.state;
    const hideBar = runningCount === 0 && waitingCount === 0;
    if (key !== '1')
      return (
        <Button
          className={styles['csx-taskcenter-clearBtn']}
          loading={clearBtnLoading}
          onClick={this.handleClearTasks}>
          清空任务
        </Button>
      );
    return (
      <Fragment>
        {!hideBar ? (
          <div className={styles['csx-taskcenter-stat-bar']}>
            执行中：
            <span>{runningCount}</span>&nbsp;&nbsp; 排队中：
            <span>{waitingCount}</span>
          </div>
        ) : null}
        <Button
          className={styles['csx-taskcenter-clearBtn']}
          loading={clearBtnLoading}
          onClick={this.handleClearTasks}>
          清空任务
        </Button>
      </Fragment>
    );
  };
  render() {
    const { pendingTasks, resolvedTasks, rejectedTasks } = this.state;
    const pendingNo = pendingTasks.length;
    const resolveNo = resolvedTasks.length;
    const rejectNo = rejectedTasks.length;
    const badgeNo = pendingNo + resolveNo + rejectNo;

    return (
      <div className={styles['csx-taskcenter-taskCenter']}>
        <div className={styles['csx-taskcenter-iconWrapper']}>
          <Badge count={badgeNo}>
            <Icon style={{ fontSize: 24 }} type="export" />
          </Badge>
        </div>
        <div className={styles['csx-taskcenter-tabs']}>
          {/* 三角形  */}
          <div className={styles['csx-taskcenter-tri']} />
          <Tabs defaultActiveKey="1" onChange={key => this.setState({ key })}>
            <TabPane tab={`执行中(${pendingNo})`} key="1">
              <List
                dataSource={pendingTasks}
                renderItem={item => this.renderItem(item, 'active', true)}
              />
            </TabPane>
            <TabPane tab={`执行完成(${resolveNo})`} key="2">
              <List
                dataSource={resolvedTasks}
                renderItem={item => this.renderItem(item, 'success', true)}
              />
            </TabPane>
            <TabPane tab={`执行失败(${rejectNo})`} key="3">
              <List
                dataSource={rejectedTasks}
                renderItem={item => this.renderItem(item, 'exception', true)}
              />
            </TabPane>
          </Tabs>
          {this.renderFooter()}
        </div>
      </div>
    );
  }
}
TaskCenter.propTypes = {
  sysCode: PropTypes.string,
  timeOut: PropTypes.number,
  history: PropTypes.object,
  taskType: PropTypes.string,
  itemExtra: PropTypes.func,
};
export default TaskCenter;
